import { observer } from 'mobx-react-lite'
import i from '../../../../translations/i'
import { Titles } from '../../../../layouts/Titles'
import __delivery from './__delivery'
import { Col, Input, InputNumber, Select, Row, Divider, Space, Button, Segmented } from 'antd'
import { ShopOutlined, CarOutlined, CreditCardOutlined, EnvironmentOutlined, TagOutlined, FileTextOutlined, DollarOutlined } from '@ant-design/icons'
import React, { useEffect } from 'react'
import { runInAction } from 'mobx'
import OptionTypesController from "../../../../components/options/optionTypes.controller";
import OptionValuesController from "../../../../components/options/optionValues.controller";
import { Options } from "../../../../components/options/Options";
import { SectionBadge, DimGroup, MasterToggle, ToggleField, FieldBlock } from "../../../../components/SectionCard";

export const SettingDeliveryBase = observer(() => {

    useEffect(() => {
        __delivery.get()
        OptionTypesController.get([], ['deliverySettingPickup', 'deliverySettingDelivery'])
          .then((keys: string[]) => OptionValuesController.get(keys))
    }, [])

    return OptionValuesController.render ? (
        <>
            <form onSubmit={(e) => {
                __delivery.save(e)
                OptionValuesController.save(e)
            }}>
                <Titles
                    title={i.t('delivery:edit')}
                    buttons={[
                        { title: i.t('def:actions.save'), type: 'primary', htmlType: 'submit' }
                    ]}
                    breadcrumb={[
                        {title: i.t('def:settings'), href: '/settings'},
                        {title: i.t('delivery:edit')},
                    ]}
                />

                <Row gutter={[20, 20]}>
                    <Col span={24} xl={12}>
                        <div className="order__block" style={{ width: '100%', height: 'auto', alignSelf: 'flex-start' }}>
                        <SectionBadge
                            icon={<ShopOutlined />}
                            text={i.t('delivery:pickup')}
                            background="linear-gradient(135deg, #3f3d56, #63607f)"
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                            <MasterToggle>
                                <Options key={`optionList1`} types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['deliverySettingPickup']} />
                            </MasterToggle>

                            <ToggleField
                                icon={<ShopOutlined />}
                                label={i.t('paymentType:ownPickup')}
                                checked={__delivery.delivery.yesPoints}
                                onChange={e => runInAction(() => __delivery.delivery.yesPoints = e)}
                            />

                            <FieldBlock icon={<TagOutlined />} label={i.t('delivery:pickupNameLabel')}>
                                <Input
                                  value={__delivery.delivery.delivery.pickupLabel}
                                  onChange={(e) => runInAction(() => __delivery.delivery.delivery.pickupLabel = e.target.value)}
                                  disabled={__delivery.delivery.delivery.pickup < 1}
                                />
                            </FieldBlock>

                            <FieldBlock icon={<FileTextOutlined />} label={i.t('delivery:pickupDescriptionLabel')}>
                                <Input
                                  value={__delivery.delivery.delivery.pickupDescription}
                                  onChange={(e) => runInAction(() => __delivery.delivery.delivery.pickupDescription = e.target.value)}
                                  disabled={__delivery.delivery.delivery.pickup < 1}
                                />
                            </FieldBlock>

                            <DimGroup active={!!__delivery.delivery.yesPoints}>
                                <FieldBlock icon={<EnvironmentOutlined />} label={i.t('delivery:pickupPointsLabel')}>
                                    <Space wrap={true}>
                                        {__delivery.delivery.places.map((el: any, index: number) => (
                                            <Button
                                                key={`places_${index}`}
                                                size="small"
                                                type={__delivery.delivery.delivery.pickup.findIndex((place_id: number) => place_id === el.id) > -1 ? 'primary' : 'dashed'}
                                                onClick={() => __delivery.setPickup(el.id)}
                                            >
                                                {el.name}
                                            </Button>
                                        ))}
                                    </Space>
                                </FieldBlock>
                            </DimGroup>
                        </div>
                        </div>
                    </Col>

                    <Col span={24} xl={12}>
                        <div className="order__block" style={{ width: '100%', height: 'auto', alignSelf: 'flex-start' }}>
                        <SectionBadge
                            icon={<CarOutlined />}
                            text={i.t('delivery:myDelivery')}
                            background="linear-gradient(135deg, var(--primary-color), #9186e0)"
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                            <MasterToggle>
                                <Options key={`optionList2`} types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['deliverySettingDelivery']} />
                            </MasterToggle>

                            <ToggleField
                                icon={<CarOutlined />}
                                label={i.t('delivery:myDelivery')}
                                checked={!!__delivery.delivery.delivery.delivery}
                                onChange={e => runInAction(() => __delivery.delivery.delivery.delivery = e ? 1 : 0)}
                            />

                            <DimGroup active={!!__delivery.delivery.delivery.delivery}>
                                <FieldBlock icon={<TagOutlined />} label={i.t('delivery:myDeliveryNameLabel')}>
                                    <Input
                                        value={__delivery.delivery.delivery.deliveryname}
                                        onChange={(e) => runInAction(() => __delivery.delivery.delivery.deliveryname = e.target.value)}
                                        disabled={__delivery.delivery.delivery.delivery < 1}
                                    />
                                </FieldBlock>

                                <FieldBlock icon={<FileTextOutlined />} label={i.t('delivery:myDeliveryDescriptionLabel')}>
                                    <Input
                                        value={__delivery.delivery.delivery.description}
                                        onChange={(e) => runInAction(() => __delivery.delivery.delivery.description = e.target.value)}
                                        disabled={__delivery.delivery.delivery.delivery < 1}
                                    />
                                </FieldBlock>
                            </DimGroup>

                            {!!__delivery.delivery.delivery.delivery &&
                                <>
                                    <Divider dashed style={{ margin: 0 }} />

                                    <FieldBlock icon={<DollarOutlined />} label={i.t('delivery:payMyDelivery')}>
                                        <Segmented
                                            options={[
                                                {label: i.t('delivery:price'), value: 1},
                                                {label: i.t('delivery:zone'), value: 2},
                                            ]}
                                            value={__delivery.delivery.delivery.typedelivery}
                                            onChange={(e) => runInAction(() => __delivery.delivery.delivery.typedelivery = e)}
                                        />
                                    </FieldBlock>

                                    <Row gutter={[16, 16]} style={{ width: '100%', margin: 0 }}>
                                        <Col span={__delivery.delivery.delivery.typedelivery === 1 ? 12 : 24} style={{ paddingLeft: 0 }}>
                                            <FieldBlock icon={<DollarOutlined />} label={i.t('delivery:minPrice')}>
                                                <InputNumber
                                                    style={{ width: `100%` }}
                                                    value={__delivery.delivery.delivery.costorder}
                                                    onChange={(e) => runInAction(() => __delivery.delivery.delivery.costorder = e)}
                                                />
                                            </FieldBlock>
                                        </Col>

                                        {__delivery.delivery.delivery.typedelivery === 1 &&
                                            <Col span={12} style={{ paddingRight: 0 }}>
                                                <FieldBlock icon={<DollarOutlined />} label={i.t('delivery:payDelivery')}>
                                                    <Input
                                                        style={{ width: `100%` }}
                                                        value={__delivery.delivery.delivery.costdelivery}
                                                        onChange={(e) => runInAction(() => __delivery.delivery.delivery.costdelivery = e.target.value)}
                                                    />
                                                </FieldBlock>
                                            </Col>
                                        }
                                    </Row>
                                </>
                            }
                        </div>
                        </div>
                    </Col>
                </Row>
            </form>
        </>
    ) : <></>
})
